import React, { useCallback, useEffect, useRef, useState } from "react";
import { styled } from "@linaria/react";
import chevron from "@assets/icon/chevron-down-grey-r3.svg";
import Button from "@components/_Revamp/Button";
import { SCREEN_SIZE } from "@static/screen-size";
import { themeDefault } from "src/theme-revamp";
import useForm from "@utils/useForm";
import { CoverageForm } from "@models/MLTC_R3/Coverage.model";
import { useAvivaSelector } from "@redux/hook";
import { validate } from "./service";
import downloadImg from "@assets/icon/download-purple.svg";
import arrowRightImg from "@assets/icon/chevron-right-white.svg";
import {
  confirmQuotation,
  updatePlanOverview,
  updatePlanSelection,
  updateSQSQuotation,
} from "@redux/slices/MLTC_R3/step2Slice";
import { useDispatch } from "react-redux";
import Stepper from "@components/_Revamp/Stepper";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import { useHistory } from "react-router-dom";
import { Helpers } from "@utils/helpers";
import { get } from "lodash";
import Modal from "@components/_Revamp/Modal";
import HowCareshieldWorks from "@assets/images/how-careshield-works.svg";
import HowCareshieldWorksMobile from "@assets/images/how-careshield-works-m.svg";
import { css } from "@linaria/core";
import { PRODUCT_SUMMARY_MLTC } from "@static/staticConstents";
import { updateCareShieldPlanName } from "@redux/slices/MLTC_R3/step5Slice";

export default function ChoosePlanTable() {
  //From choose plan old
  const basicDetails = useAvivaSelector(
    (state) => state.mltcR3Step1.basicDetails
  );
  const initValue = useAvivaSelector((state) => state.mltcR3Step1.coverage);
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param
  );
  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams
  );
  const avivaBrochureUrlMltc = get(
    window,
    "AVIVA_VARIABLE_CONFIG.brochureUrlMltc"
  );

  const history = useHistory();
  ///Choose Plan Table
  const planSelectedRef = useRef("");
  const currentPlanSelected = useAvivaSelector(
    (state) => state.mltcR3Step2.planSelection
  );
  const [planLabelMLTC, setPlanLabelMLTC] = useState("Select plan");
  const [planLabelMLTCP, setPlanLabelMLTCP] = useState("Select plan");
  const [planSelection, setPlanSelection] = useState<number | string>(-1);
  const [isQuoteBreakdown, setQuoteBreakdown] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const qrClientDetails = useAvivaSelector(
      (state) => state.mltcR3Step5.qrClientDetails,
    );
  const validQRClient = qrClientDetails?.status === "SUCCESS";

  const dispatch = useDispatch();
  // const timerRef = useRef<number | undefined>(undefined);
  const LabelUpdater = useCallback((planName, e) => {
    if (planName === "MLTC") {
      setPlanLabelMLTCP("Select plan");
      setPlanLabelMLTC("Deselect");
    }
    if (planName === "MLTCP") {
      setPlanLabelMLTCP("Deselect");
      setPlanLabelMLTC("Select plan");
    }
    if (planName === "deselect") {
      if (e === "MLTC") {
        setPlanLabelMLTC("Select plan");
      } else if (e === "MLTCP") {
        setPlanLabelMLTCP("Select plan");
      }
    }
  }, []);

  const { handleChange, values, errors, formValid, patchValue } = useForm(
    new CoverageForm(initValue),
    () => {},
    validate
  );
  const planOptions = {
    options: [
      {
        value: "MLTC",
        description: `Singlife CareShield Standard`,
        key: "myCareEnhanced",
      },
      {
        value: "MLTCP",
        description: `Singlife CareShield Plus`,
        key: "myCarePlusEnhanced",
      },
    ],
  };
  const onPlanSelection = (planSelection: string) => {
    let obj = [
      {
        heading: { text: "Plan Overview" },
        descriptions: [
          {
            text: "Plan selected",
            value: `${
              planSelection === "MLTC"
                ? planOptions.options[0].description
                : planOptions.options[1].description
            }`,
          },
          { text: "Monthly benefit", value: `-` },
        ],
      },
      {
        heading: { text: "Premium breakdown" },
        descriptions: [
          {
            text: "Annual premium",
            value: `-`,
          },
          {
            text: 'Promo Code: <a class="insertPromoCodeClass">Edit</a>',
            value: "-",
          },
        ],
      },
    ];

    obj[1].descriptions.push({
      text: "CPF MediSave deduction",
      value: `-`,
    });
    if (!planSelection) {
      dispatch(updatePlanOverview(null));
    } else {
      dispatch(updatePlanOverview({ quoteBreakdown: obj }));
    }
  };
  const resetQuoteListing = () => {
    dispatch(updateSQSQuotation(null));
    dispatch(confirmQuotation(false));
  };
  const planSelectorHandler = (input: string, planName: string) => {
    // clearTimeout(timerRef.current);
    LabelUpdater(input, planName);
    if (input === "deselect") {
      input = "";
    }
    handleChange({
      target: {
        name: "plan",
        value: input,
      },
    });
    setPlanSelection((prev) => {
      if (input !== prev) {
        //When plan change, reset the header component view plan amount
        resetQuoteListing();
      }
      return input;
    });
    onPlanSelection(input);
    dispatch(updatePlanSelection(input));
    setQuoteBreakdown(false);
  };

  const stepsList: Step[] = [
    {
      label: "Basic Info",
      isCurrentStep: false,
      path: "/mltc/lets-get-started",
      disabled: validQRClient
    },
    {
      label: "Quote",
      isCurrentStep: true,
      path: "/mltc/choose-plan",
    },
    {
      label: "Health Declaration",
      isCurrentStep: false,
      path: "/mltc/health",
    },
    {
      label: "Start Application",
      isCurrentStep: false,
      path: "/mltc/my-info",
    },
    {
      label: "Review & Payment",
      isCurrentStep: false,
      path: "/mltc/review",
    },
  ];

  //From choose plan
  const onBack = useCallback(() => {
    history.push("/mltc/lets-get-started" + paramCC + analyticParam);
  }, [history]);

  const handleCloseModal = () => setIsShowModal(false);

  //Validate if the previos basic info collection step was completed.
  useEffect(() => {
    if (!basicDetails) {
      onBack();
      return;
    }
    if (currentPlanSelected) {
      LabelUpdater(currentPlanSelected, "");
      planSelectedRef.current = currentPlanSelected;
    }
  }, []);

  useEffect(()=>{
    dispatch(updateCareShieldPlanName(currentPlanSelected));
    dispatch(updatePlanSelection(currentPlanSelected));
  },[currentPlanSelected])

  return (
    <>
      <Container>
        <div>
          <TableContainer>
            <TableScrollHolder>
              <Table>
                <tr>
                  <th className="stopscroll mobileheadcol">
                    <div>Key Features</div>
                  </th>
                  <PolicyTitleContainer
                    isSelected={planSelectedRef.current === "MLTC"}
                    onMouseOver={() => {
                      if (currentPlanSelected === "MLTC") {
                        setPlanLabelMLTC("Deselect");
                      }
                    }}
                    onMouseLeave={() => {
                      if (currentPlanSelected === "MLTC") {
                        setPlanLabelMLTC("Selected");
                      }
                    }}
                    onClick={() => {
                      if (
                        planSelectedRef.current === "" ||
                        planSelectedRef.current === "MLTCP"
                      ) {
                        planSelectedRef.current = "MLTC";
                        planSelectorHandler("MLTC", "MLTC");
                      } else {
                        planSelectedRef.current = "";
                        planSelectorHandler("deselect", "MLTC");
                      }
                    }}
                  >
                    <div>
                      <span>Singlife CareShield Standard</span>
                      <Button
                        variant={"secondary"}
                        margin="16px auto auto"
                        height="52px"
                        label={planLabelMLTC}
                      />
                    </div>
                  </PolicyTitleContainer>
                  <PolicyTitleContainer
                    id="MLTCP"
                    isSelected={planSelectedRef.current === "MLTCP"}
                    onMouseOver={() => {
                      if (currentPlanSelected === "MLTCP") {
                        setPlanLabelMLTCP("Deselect");
                      }
                    }}
                    onMouseLeave={() => {
                      if (currentPlanSelected === "MLTCP") {
                        setPlanLabelMLTCP("Selected");
                      }
                    }}
                    onClick={(e) => {
                      if (
                        planSelectedRef.current === "" ||
                        planSelectedRef.current === "MLTC"
                      ) {
                        planSelectedRef.current = "MLTCP";
                        planSelectorHandler("MLTCP", "MLTCP");
                      } else {
                        planSelectedRef.current = "";
                        planSelectorHandler("deselect", "MLTCP");
                      }
                    }}
                  >
                    <div>
                      <span>Singlife CareShield Plus</span>
                      <Button
                        variant={"secondary"}
                        margin="16px auto auto"
                        height="52px"
                        width="100%"
                        label={planLabelMLTCP}
                      />
                    </div>
                  </PolicyTitleContainer>
                </tr>
                <tbody>
                  <tr>
                    <td className="mobileheadcol">
                      <input
                        className="checkbox"
                        type="checkbox"
                        id="adl"
                        defaultChecked
                      />
                      <label className="td-heading" htmlFor="adl">
                        <div className="td-feature-description">
                          <div className="td-feature-descriptio-title">
                            <span>
                              <img
                                className="td-chevron"
                                src={chevron}
                                alt="chevron"
                              />
                            </span>
                            <span>
                              Activities of Daily Living (ADL) Coverage
                            </span>
                          </div>
                          <div className="td-feature-details">
                            <div>
                              The 6 <b>ADLs</b> are:
                            </div>
                            Dressing, washing, toileting, walking or moving
                            around, transferring and feeding
                          </div>
                        </div>
                      </label>
                    </td>
                    <Td isSelected={planSelectedRef.current === "MLTC"}>
                      <div>Payouts when policyholder is unable to perform</div>
                      <b>3 or more ADLs</b>
                    </Td>
                    <Td isSelected={planSelectedRef.current === "MLTCP"}>
                      <div>Payouts when policyholder is unable to perform</div>
                      <b>2 or more ADLs</b>
                    </Td>
                  </tr>
                  <tr>
                    <td className="mobileheadcol">
                      <input type="checkbox" id="monthly-benefit-amount" />
                      <label
                        className="td-heading"
                        htmlFor="monthly-benefit-amount"
                      >
                        <div className="td-feature-description">
                          <div className="td-feature-descriptio-title">
                            <span>
                              <img
                                className="td-chevron"
                                src={chevron}
                                alt="chevron"
                              />
                            </span>
                            <span>Personalised Monthly Benefit Amount</span>
                          </div>
                          <div className="td-feature-details">
                            This is customisable and in increments of S$100,
                            which is paid out for a lifetime.
                          </div>
                        </div>
                      </label>
                    </td>
                    <Td isSelected={planSelectedRef.current === "MLTC"}>
                      <div>
                        <b> S$200 </b>to<b> S$5,000 monthly</b>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          marginLeft: "-5px",
                        }}
                      >
                        (on top of CareShield Life&apos;s payout)
                      </div>
                    </Td>
                    <Td isSelected={planSelectedRef.current === "MLTCP"}>
                      <div>
                        <b> S$200 </b>to<b> S$5,000 monthly</b>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          marginLeft: "-5px",
                        }}
                      >
                        (on top of CareShield Life&apos;s payout)
                      </div>
                    </Td>
                  </tr>
                  <tr>
                    <td className="mobileheadcol">
                      <input
                        className="checkbox"
                        type="checkbox"
                        id="add-on-benefit"
                      />
                      <label className="td-heading" htmlFor="add-on-benefit">
                        <div className="td-feature-description">
                          <div className="td-feature-descriptio-title">
                            <span>
                              <img
                                className="td-chevron"
                                src={chevron}
                                alt="chevron"
                              />
                            </span>
                            <span>Add-on Benefit</span>
                          </div>
                          <div className="td-feature-details">
                            Selected monthly benefit payout for up to 12 months
                          </div>
                        </div>
                      </label>
                    </td>
                    <Td isSelected={planSelectedRef.current === "MLTC"}>
                      <div>Payouts when policyholder is unable to perform</div>
                      <b>2 ADLs</b>
                    </Td>
                    <Td isSelected={planSelectedRef.current === "MLTCP"}>
                      <div>Payouts when policyholder is unable to perform</div>
                      <b>1 ADL</b>
                    </Td>
                  </tr>
                </tbody>
              </Table>
            </TableScrollHolder>
            <div className="tr-row">
              <div
                onClick={() => {
                  window.open(
                    PRODUCT_SUMMARY_MLTC,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
                className="link"
              >
                <img src={downloadImg} alt="download-icon" />
                <span>Read our Product Summary</span>
              </div>
              <div
                onClick={(e) => {
                  window.open(
                    avivaBrochureUrlMltc,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
                className="link"
              >
                <img src={downloadImg} alt="download-icon" />
                <span>Read our Product Brochure</span>
              </div>
            </div>
            <div className="tr-row tr-last-row">
              <div
                onClick={() => {
                  setIsShowModal(true);
                }}
              >
                Find out how Singlife CareShield Standard&#47;Plus works
                <img src={arrowRightImg} alt="arrow-icon" />
              </div>
            </div>
          </TableContainer>
          <Note>
            Note: Age next birthday is the age on your next birthday, which is
            your current age plus 1 year. All ages mentioned in this purchase
            journey refer to age next birthday.
          </Note>
          <CustomiseButton disabled={!currentPlanSelected}>
            <Button
              disabled={!currentPlanSelected}
              onClick={() => {
                history.push("/mltc/customise-plan");
              }}
              label="Customise plan"
            />
          </CustomiseButton>
        </div>
        <Stepper steps={stepsList}></Stepper>
      </Container>

      <Modal
        show={isShowModal}
        className={helpAndrewCSS}
        onClose={handleCloseModal}
        isErrorModal
      >
        <HelpAndrew>
          <img alt={"how_careshield_works"} src={HowCareshieldWorks} />
          <img alt={"how_careshield_works"} src={HowCareshieldWorksMobile} />
          <Button onClick={handleCloseModal} label="Close" />
        </HelpAndrew>
      </Modal>
    </>
  );
}

const HelpAndrew = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    &:nth-child(1) {
      @media screen and (max-width: 767px) {
        display: none;
      }
    }

    &:nth-child(2) {
      @media screen and (min-width: 768px) {
        display: none;
      }
    }
  }
  button {
    width: 180px;
    height: 52px;
    padding: 16px 60px;
    margin-top: 10px;
  }
`;
const helpAndrewCSS = css`
  .modal-content {
    max-width: 920px;
    max-height: 90vh;

    .modal-body {
      background: #fafafa;
      padding: 24px;
    }
  }
`;

const CustomiseButton = styled.div<{ disabled: boolean }>`
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  button {
    margin-top: 64px;
    width: 190px;
    &:hover {
      box-shadow: ${(props) =>
        props.disabled ? "none" : "0px 1px 20px rgba(0, 0, 0, 0.1)"};
    }
  }
`;

const Container = styled.div`
  margin: auto;
  max-width: 792px;
  margin-top: 164px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-top: 200px;
  }
`;

const Td = styled.td<{ isSelected: boolean }>`
  background: ${(props) => (props.isSelected ? "#F2E6F1" : "#FFF")};
`;

const PolicyTitleContainer = styled.th<{ isSelected: boolean }>`
  cursor: pointer;
  transition: all 0.3s linear;
  color: ${(props) => (props.isSelected ? "white" : "")};
  background: ${(props) =>
    props.isSelected ? themeDefault.colors.primary : "#F5F5F5"};
  div > button {
    font-size: 14px;
  }
  & > div {
    font-size: 16px;
    text-align: start;
  }
  span {
    display: block;
    font-size: 16px;
    line-height: 140%;
    width: 144px;
    margin-bottom: 1px;
  }
  span:after {
    content: "";
    display: block;
    width: ${(props) => (props.isSelected ? "66px" : "0px")};
    border: ${(props) =>
      props.isSelected
        ? `1px solid ${themeDefault.colors.white}`
        : "1px solid transparent"};
    transition: all 0.3s linear;
  }
  &:hover {
    background: ${(props) => (props.isSelected ? "#B474B0" : "#F5F5F5")};
    span {
      margin-bottom: 0px;
    }
    div > button {
      background-color: ${(props) =>
        props.isSelected
          ? themeDefault.colors.white
          : themeDefault.colors.primary};
      color: ${(props) =>
        props.isSelected
          ? themeDefault.colors.primary
          : themeDefault.colors.white};
    }
    span:after {
      content: "";
      display: block;
      width: ${(props) => (props.isSelected ? "0px" : "66px")};
      border: ${(props) =>
        props.isSelected ? `1px solid transparent` : "1px #883e89 solid"};
    }
  }
`;

const Table = styled.table`
  width: 100%;
  /* overflow-x: scroll; */
  box-sizing: border-box;
  /* position: relative; */
  input {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  border-spacing: 0;
  border-bottom: 1px solid #d8d8d8;
  line-height: 140%;
  th,
  td {
    box-sizing: border-box;
    position: relative;
    border-right: 1px solid #d8d8d8;
    border-top: 1px solid #d8d8d8;
  }
  th:nth-last-child(1),
  td:nth-last-child(1) {
    box-sizing: border-box;
    position: relative;
    border-right: unset;
  }
  tr:nth-child(1) {
    border-left: 1px solid #d8d8d8;
  }
  tr > th {
    &:nth-child(1) {
      background: #f5f5f5;
    }
    div {
      height: 100%;
    }
    min-width: 214px;
    max-width: 214px;
    padding: 24px 18px 31px 24px;
    height: 166px;
  }
  tr > th:not(:first-child) {
    padding: 32px 16px 17px 16px;
  }
  //Font size for Table header
  th {
    font-weight: 600;
    font-size: 18px;
  }

  //Font size for table details
  td {
    font-weight: 400;
    font-size: 14px;
  }
  .td-chevron {
    transform: rotate(-90deg);
  }
  //TD for policy features
  td:not(:first-child) {
    max-width: 176px;
    padding: 16px;
    text-align: center;
    b {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 140%;
    }
  }
  //TD style
  td {
    label {
      display: flex;
    }
    padding: 8px;
    padding-left: 16px;
    .td-heading {
      & > div {
        padding-left: 8px;
      }
      .td-feature-descriptio-title {
        display: flex;
        gap: 8px;
      }
      cursor: pointer;
      font-weight: 600;
    }
  }
  //Feature deatils
  .td-feature-details {
    padding-left: -12px;
    font-weight: 400;
    margin-top: 8px;
    height: 0px;
    overflow: hidden;
    transition: height 0.3s linear;
    b {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 140%;
    }
  }
  input:checked {
    + label div .td-chevron {
      transform: rotate(0deg);
    }
    + label .td-feature-details {
      height: 100%;
      transition: height 0.3s linear;
    }
  }
  //////////////////////////////
  ///Desktop and Tab version///
  ////////////////////////////
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    & {
      border-bottom: unset;
      th:nth-child(1) {
        font-size: 28px;
        text-align: start;
      }
      tr:nth-last-child(1),
      th:nth-last-child(1) {
        border-right: unset;
      }
      th:nth-last-child(1),
      td:nth-last-child(1) {
        box-sizing: border-box;
        position: relative;
        border-right: unset;
        border-top: 1px solid #d8d8d8;
      }
      th:nth-last-child(1) {
        border-top: unset;
      }
      td:not(:first-child) {
        width: 214px;
        padding: 16px;
        text-align: center;
        b {
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 140%;
        }
      }
      th {
        border-top: unset;
      }
      tr:nt-child(1) {
        border-top: unset;
      }
      th:nth-child(1),
      td:nth-child(1) {
        border-left: unset;
        max-width: 364px;
      }
      td {
        pointer-events: none;
        padding: 0px;
        input {
          display: none;
        }
        label {
          .td-feature-description {
            padding: 24px 15px 24px 24px;
          }
          .td-feature-descriptio-title {
            span:nth-child(1) {
              display: none;
            }
          }
          .td-feature-details {
            height: 100%;
          }
        }
      }
    }
    .td-feature-details {
      margin-top: 24px;
      font-weight: 400;
      padding-left: 12px;
    }
    .td-chevron {
      display: none;
    }
  }

  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp - 1}px) {
    padding-top: 10px;
    tr > th {
      &:nth-child(1) {
        box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.25);
      }
    }
    .mobileheadcol {
      position: -webkit-sticky;
      position: sticky;
      width: 176px;
      min-width: 176px;
      max-width: 176px;
      left: 0;
      background-color: #fff;
      z-index: 10;
      box-shadow: 2px 4px 8px 0px rgba(0, 0, 0, 0.25);
      border-right: 0;
    }
  }
`;

const TableContainer = styled.div`
  width: 100%;
  overflow: hidden;
  .tr-row {
    &.tr-last-row {
      background: #883E89;
      color: #fff;
      text-decoration: none;
    }
    img {
      color: #883e89;
    }
    div {
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 8px;
      font-weight: 600;
      &.link {
        span {
          margin-top: 6px;
        }
      }
    }
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    color: #883e89;
    text-decoration: underline;
    font-size: 14px;
    gap: 16px;
    align-items: center;
    /* border-top: 1px solid #d8d8d8; */
    padding: 16px 24px 16px 24px;
    max-width: 788px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    overflow: hidden;
    border: 1px solid #d8d8d8;
    border-radius: 24px;
    .tr-row {
      flex-direction: row;
      gap: 64px;
      border-top: 0px;
      border-top: 1px solid #d8d8d8;
    }
  }
`;

const Note = styled.p`
  font-size: 14px;
  font-weight: 500;
  margin-top: 24px;
  padding: 0 24px;
  color: #434343;
`;

const TableScrollHolder = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
  width: 100%;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    overflow: hidden;
  }
`;
